// extracted by mini-css-extract-plugin
export default {"catalogContainer":"DigitalMagazine_catalogContainer__KyvGi"};